var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('v-progress-circular',{attrs:{"size":90,"width":7,"indeterminate":"","color":"#93BA1F"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }